export default __webpack_public_path__ + "static/media/knight.dd7f16cb.png";